"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeMessages_en_us = void 0;
function backofficeMessages_en_us() {
    return {
        "backoffice.messages.subtitle": "Messages are sent automatically by the system. Messages cannot be sent as a user.",
        "backoffice.messages.nodata": "No messages",
        "backoffice.messages.nodatatitle": "No messages yet.",
        "backoffice.messages.nodatasubtitle": "You will be notified as soon as a new message has been received from the system. Look for the bell symbol in the top right next to your profile name.",
        "backoffice.messages.nolink": "No link",
        "backoffice.messages.nosender": "unknown",
        "backoffice.messages.details": "Message Details",
        "backoffice.messages.title.main": "Messages",
        "backoffice.messages.title.private": "Private Messages",
        "backoffice.messages.title.project": "Messages to Projects",
        "backoffice.messages.list.tenant.reseller": "Backoffice",
        "backoffice.messages.list.tenant.company": "Company",
        "backoffice.messages.list.tenant.project": "Project",
        "backoffice.messages.list.tenant.user": "User",
        "backoffice.messages.list.tenant.unknown": "Unknown sender",
        "backoffice.messages.list.table.date": "Date",
        "backoffice.messages.list.table.from": "Sender",
        "backoffice.messages.list.table.toproject": "To Project",
        "backoffice.messages.list.table.messageid": "Message ID",
        "backoffice.messages.list.table.message": "Message",
        "backoffice.messages.list.table.links": "Links",
        "backoffice.messages.list.table.actions": "Actions",
        "backoffice.messages.list.table.markasread": "Mark as read",
        "backoffice.messages.list.markasread": "Mark message(s) as read"
    };
}
exports.backofficeMessages_en_us = backofficeMessages_en_us;
